<section class="header">
    <div class="title">
      <div class="m-l-1"><img src="/assets/img/logo-white.svg"></div>
      <button class="button normal m-r-1"><a href="#">Signup</a></button>
    </div>
    <div class="clip"></div>
  </section>
  